/** Pending shared-license invite — must be accepted or declined, not deleted. */
export const LICENSE_SHARING_INVITE_TYPE = 'license_request';

export function isLicenseSharingInviteNotification(notification) {
  return notification?.type === LICENSE_SHARING_INVITE_TYPE;
}
